
export type ITSLogicIsNever<T, Y = true, N = false> = [T] extends [never] ? Y : N
